<ng-container *ngIf="!!get">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input-number
            ttLabelView="top"
            ttLabel="pcs_to_pick_after_optimalization"
            [(ttModel)]="get.quantity_to_pick"
            (ttModelChange)="onChange('quantity_to_pick')"
            ttFormatNumber
            ttTextAlign="right"
            ttDecimals="2"
        ></tt-input-number>
        <tt-input-number
            ttLabelView="top"
            ttLabel="stock_quantity_after_optimalization"
            [(ttModel)]="get.stock_quantity_after_optimalization"
            (ttModelChange)="onChange('stock_quantity_after_optimalization')"
            ttFormatNumber
            ttTextAlign="right"
            ttDecimals="2"
        ></tt-input-number>
        <tt-button-save ttText="cuttingplanreal_save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <!-- <tt-button ttText="cuttingplanreal_distribute" (ttClick)="distribute()" [ttLoading]="distributing"></tt-button> -->
    </tt-card>
    <tt-grid *ngIf="!!grid" [(ttOptions)]="grid"></tt-grid>
</ng-container>
